import { gql } from '@apollo/client';

export const UPDATE_FORM_TEMPLATE = gql`
  mutation UpdateFormTemplate($input: UpdateFormTemplateInput!, $id: ID!) {
    updateFormTemplate(input: $input, id: $id) {
      id
      name
      pages
      createdAt
      updatedAt
    }
  }
`;

export const CREATE_FORM_TEMPLATE = gql`
  mutation CreateFormTemplate($input: FormTemplateInput!) {
    createFormTemplate(input: $input) {
      id
      ownerId
      isPublic
      name
      pages
      createdAt
      updatedAt
    }
  }
`;

export const GET_ALL_FORM_TEMPLATES_FOR_CURRENT_USER = gql`
  query GetAllFormTemplatesForCurrentUser {
    getAllFormTemplatesForCurrentUser {
      id
      ownerId
      isPublic
      name
      pages
      isAnonymous
      isInfinitelyRespondable
      isPasscodeRequired
      changesPublished
      versionIds
      welcomePageRichText
      completionButtonLabel
      createdAt
      updatedAt
    }
  }
`;

export const GET_ALL_FORM_TEMPLATES_FOR_CURRENT_USER_IF_HAS_VERSION = gql`
  query GetAllFormTemplatesForCurrentUserIfHaveVersions {
    getFormTemplatesForCurrentUserOnlyIfTheyHaveVersions {
      id
      ownerId
      isPublic
      name
      pages
      isAnonymous
      isInfinitelyRespondable
      isPasscodeRequired
      changesPublished
      mostRecentVersion {
        id
        name
        createdAt
        updatedAt
      }
      welcomePageRichText
      completionButtonLabel
      createdAt
      updatedAt
    }
  }
`;

export const GET_FORM_TEMPLATE_BY_ID = gql`
  query GetFormTemplateById($id: ID!) {
    getFormTemplateById(id: $id) {
      id
      ownerId
      isPublic
      name
      pages
      createdAt
      updatedAt
    }
  }
`;

export const DUPLICATE_FORM_TEMPLATE = gql`
  mutation DuplicateFormTemplate($input: DuplicateFormTemplateInput!) {
    duplicateFormTemplate(input: $input) {
      id
      name
      pages
      createdAt
      updatedAt
    }
  }
`;

export const DELETE_FORM_TEMPLATE = gql`
  mutation DeleteFormTemplate($id: ID!) {
    deleteFormTemplate(id: $id)
  }
`;
